import React, { Component } from "react";
import Api from "Api/Api";
import Utils from "Utils";
export default class AddBidForm extends Component {
  // Form to sell a startup
  constructor(props) {
    super(props);
    this.submitForSell = e => {
      e.preventDefault();
      // var data = {
      //   // shares_for_sale: e.target.shares_for_sale.value
      //   // last_share_price: e.target.last_share_price.value
      // };
      // hit the api to save the data for the selling the stake of a startup
      Api.initiateSelling(
        props.startup.id,
        e.target.shares_for_sale.value
      ).then(response => {
        if (![200, 201].includes(response.status)) {
          Utils.notify(response.data.error, "warning");
        }
        this.props.upForSale();
      });
    };
  }
  render() {
    return (
      <>
        {/* TODO to update the share number and share price data */}
        {/* <h3>Your Shares</h3> */}
        {/* <p>Number of shares:- {this.props.startup.share_number}</p>
        <p>Share price:-{this.props.share_price}</p>
        <p>Equity price:-{this.props.equity_percent}</p> */}
        <form onSubmit={this.submitForSell}>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label className="bmd-label-floating">
                  Total number of share you want to sell
                </label>
                <input
                  type="number"
                  className="form-control"
                  name="shares_for_sale"
                />
              </div>
            </div>
          </div>
          <button type="submit" className="btn btn-primary pull-right">
            Up for sale
          </button>
          <div className="clearfix"></div>
        </form>
      </>
    );
  }
}
